import React from 'react'
import { SelectSingleProps } from './interface'
import SelectSingle from './SelectSingle'

const Select = <V = unknown, >(props: SelectSingleProps<V>) => {
  return <SelectSingle {...props} />
}

// eslint-disable-next-line no-lone-blocks
{ /* Select.Multi = <V = unknown>(props: SelectMultiProps<V[]>) => {
  return <SelectMulti<V[]> {...props} />
} */ }

export default Select
